(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ra-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!window.raLegalGuaranteeReady) {
  window.raLegalGuaranteeReady = true;
  const states = new WeakMap();
  const reset = dialog => {
    const state = states.get(dialog);
    const image = dialog.querySelector('[data-ra-guarantee-image]');
    const viewer = dialog.querySelector('[data-ra-guarantee-viewer]');
    image.removeAttribute('data-zoomed');
    image.style.removeProperty('width');
    viewer.scrollLeft = 0;
    viewer.scrollTop = 0;
    state.factor = 1;
    state.baseWidth = image.getBoundingClientRect().width || viewer.clientWidth;
    dialog.querySelector('[data-ra-guarantee-zoom="out"]').disabled = true;
    dialog.querySelector('[data-ra-guarantee-zoom="in"]').disabled = false;
    const status = dialog.querySelector('[data-ra-guarantee-zoom-status]');
    status.textContent = status.dataset.pattern.replace('__FACTOR__', '1');
  };
  const prepare = dialog => {
    if (states.has(dialog)) return;
    states.set(dialog, { trigger: null, factor: 1, baseWidth: 0 });
    dialog.addEventListener('cancel', event => { event.preventDefault(); dialog.close(); });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('[data-ra-guarantee-dialog][open]')) document.documentElement.classList.remove('ra-guarantee-open');
      const trigger = states.get(dialog).trigger;
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    });
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-ra-guarantee-open]');
    if (opener) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const dialog = document.getElementById(opener.dataset.raGuaranteeOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      prepare(dialog);
      states.get(dialog).trigger = opener;
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('ra-guarantee-open');
      reset(dialog);
      dialog.querySelector('h2').focus({ preventScroll: true });
      dialog.querySelector('.ra-guarantee__body').scrollTop = 0;
      return;
    }
    const closer = event.target.closest('[data-ra-guarantee-close]');
    if (closer) { closer.closest('dialog').close(); return; }
    const control = event.target.closest('[data-ra-guarantee-zoom]');
    if (!control) return;
    const dialog = control.closest('dialog');
    const state = states.get(dialog);
    if (!state || !dialog.open) return;
    if (control.dataset.raGuaranteeZoom === 'fit') { reset(dialog); return; }
    const image = dialog.querySelector('[data-ra-guarantee-image]');
    const viewer = dialog.querySelector('[data-ra-guarantee-viewer]');
    const naturalWidth = image.naturalWidth || Number(image.getAttribute('width'));
    const maxFactor = Math.max(8, naturalWidth / state.baseWidth);
    const previous = state.factor;
    state.factor = control.dataset.raGuaranteeZoom === 'original' ? naturalWidth / state.baseWidth : Math.max(1, Math.min(maxFactor, previous + (control.dataset.raGuaranteeZoom === 'in' ? .5 : -.5)));
    if (state.factor <= 1) { reset(dialog); return; }
    image.setAttribute('data-zoomed', '');
    image.style.width = `${state.baseWidth * state.factor}px`;
    const ratio = state.factor / previous;
    viewer.scrollLeft = (viewer.scrollLeft + viewer.clientWidth / 2) * ratio - viewer.clientWidth / 2;
    viewer.scrollTop = (viewer.scrollTop + viewer.clientHeight / 2) * ratio - viewer.clientHeight / 2;
    dialog.querySelector('[data-ra-guarantee-zoom="out"]').disabled = state.factor <= 1;
    dialog.querySelector('[data-ra-guarantee-zoom="in"]').disabled = state.factor >= maxFactor;
    const status = dialog.querySelector('[data-ra-guarantee-zoom-status]');
    status.textContent = status.dataset.pattern.replace('__FACTOR__', String(Math.round(state.factor * 10) / 10));
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-ra-guarantee-dialog][open]')) document.documentElement.classList.remove('ra-guarantee-open');
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-whatsapp"] && !Shopify.designMode) return;
  try {
    if (!window.raWhatsappInitialized) {
  window.raWhatsappInitialized = true;
  const links = () => [...document.querySelectorAll('[data-ra-whatsapp]')];
  const update = () => {
    const sticky = document.querySelector('[data-ra-sticky]');
    const isMobile = matchMedia('(max-width:899px)').matches;
    const height = sticky && !sticky.hidden && getComputedStyle(sticky).display !== 'none' ? sticky.getBoundingClientRect().height : 0;
    const modalOpen = Boolean(document.querySelector('dialog[open]'));
    links().forEach(link => { link.style.setProperty('--ra-whatsapp-clearance', isMobile && height ? `${Math.ceil(height)}px` : '0px'); link.hidden = modalOpen; });
  };
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); };
  new MutationObserver(records => { if (records.some(record => (record.type === 'childList' && [...record.addedNodes].some(node => node.nodeType === 1)) || (record.target.matches?.('[data-ra-sticky],dialog') && record.type === 'attributes'))) schedule(); }).observe(document.body, { subtree:true, childList:true, attributes:true, attributeFilter:['hidden','open','class'] });
  const sticky = document.querySelector('[data-ra-sticky]');
  if (sticky) new ResizeObserver(schedule).observe(sticky);
  window.addEventListener('resize', schedule, { passive:true });
  update();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-wishlist"] && !Shopify.designMode) return;
  try {
    if (!window.raWishlistInitialized) {
  window.raWishlistInitialized = true;
  const storageKey = 'regenage-favorites-v1';
  let memory = new Set();
  let storageOK = true;
  let trigger = null;
  const catalog = () => new Set([...document.querySelectorAll('[data-ra-wishlist-item]')].map(item => item.dataset.raWishlistItem));
  const clean = value => new Set(Array.isArray(value) ? value.filter(id => typeof id === 'string' && /^\d+$/.test(id) && id !== '9977690423624').slice(0, 100) : []);
  try { memory = clean(JSON.parse(localStorage.getItem(storageKey) || '[]')); } catch (error) { storageOK = false; }
  function write() {
    try { localStorage.setItem(storageKey, JSON.stringify([...memory])); } catch (error) { storageOK = false; }
  }
  function sync() {
    const available = catalog();
    if (available.size) {
      const before = memory.size;
      memory = new Set([...memory].filter(id => available.has(id)));
      if (before !== memory.size) write();
    }
    document.querySelectorAll('[data-ra-wishlist-count]').forEach(item => { item.textContent = String(memory.size); });
    document.querySelectorAll('[data-ra-wishlist-open]').forEach(button => { button.hidden = false; });
    document.querySelectorAll('[data-ra-wishlist-toggle]').forEach(button => {
      const selected = memory.has(button.dataset.raWishlistToggle);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', selected ? button.dataset.labelRemove : button.dataset.labelAdd);
    });
    document.querySelectorAll('[data-ra-wishlist-item]').forEach(item => { item.hidden = !memory.has(item.dataset.raWishlistItem); });
    document.querySelectorAll('[data-ra-wishlist-empty]').forEach(item => { item.hidden = memory.size > 0; });
    document.querySelectorAll('[data-ra-wishlist-clear]').forEach(button => { button.hidden = memory.size === 0; });
    document.querySelectorAll('[data-ra-wishlist-storage]').forEach(item => { item.hidden = storageOK; });
  }
  function announce(key) {
    document.querySelectorAll('[data-ra-wishlist-status]').forEach(item => { item.textContent = item.dataset[key] || ''; });
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-ra-wishlist-toggle]');
    if (toggle) {
      const id = toggle.dataset.raWishlistToggle;
      if (!/^\d+$/.test(id) || id === '9977690423624') return;
      const selected = memory.has(id);
      if (selected) memory.delete(id); else memory.add(id);
      write(); sync(); announce(selected ? 'removed' : 'added');
      const root = toggle.closest('[data-ra-wishlist-root]');
      if (root && selected) (root.querySelector('[data-ra-wishlist-item]:not([hidden]) button') || root.querySelector('[data-ra-wishlist-close]') || root.querySelector('a.ra-button-secondary')).focus();
      return;
    }
    const opener = event.target.closest('[data-ra-wishlist-open]');
    if (opener) {
      const dialog = document.getElementById('RaWishlistDialog');
      if (dialog && !dialog.open) { trigger = opener; sync(); dialog.showModal(); }
      return;
    }
    if (event.target.closest('[data-ra-wishlist-close]')) document.getElementById('RaWishlistDialog')?.close();
    const clear = event.target.closest('[data-ra-wishlist-clear]');
    if (clear) {
      memory.clear(); write(); sync(); announce('cleared');
      (clear.closest('[data-ra-wishlist-root]').querySelector('[data-ra-wishlist-close]') || clear.closest('[data-ra-wishlist-root]').querySelector('a.ra-button-secondary')).focus();
    }
  });
  function initDialogs() {
    document.querySelectorAll('dialog[data-ra-wishlist-root]').forEach(dialog => {
      if (dialog.dataset.raReady) return;
      dialog.dataset.raReady = 'true';
      dialog.addEventListener('close', () => { if (trigger?.isConnected) trigger.focus(); });
      dialog.addEventListener('click', event => { const rect = dialog.getBoundingClientRect(); if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close(); });
    });
  }
  window.addEventListener('storage', event => { if (event.key === storageKey || event.key === null) { try { memory = clean(JSON.parse(event.newValue || '[]')); } catch (error) { memory = new Set(); } sync(); } });
  const observer = new MutationObserver(records => { if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-ra-wishlist-root],[data-ra-wishlist-toggle],[data-ra-wishlist-open]') || node.querySelector?.('[data-ra-wishlist-root],[data-ra-wishlist-toggle],[data-ra-wishlist-open]'))))) { sync(); initDialogs(); } });
  observer.observe(document.body, { childList: true, subtree: true });
  sync(); initDialogs();
}
  } catch(e) { console.error(e); }
})();

})();
